/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Box, CircularProgress } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type { IconProps } from 'react-toastify';

const icons = {
  success: CheckCircleOutlineRoundedIcon,
  warning: WarningAmberRoundedIcon,
  error: ErrorOutlineRoundedIcon,
  info: InfoOutlinedIcon,
  default: InfoOutlinedIcon,
};

/** Round tinted status icon — the only place an alert toast shows its severity colour. */
export default function AlertToastIcon({
  type,
  isLoading,
}: Readonly<Pick<IconProps, 'type' | 'isLoading'>>) {
  const color = type === 'success' || type === 'warning' || type === 'error' ? type : 'primary';
  const Icon = icons[type] ?? InfoOutlinedIcon;
  return (
    <Box
      aria-hidden
      sx={(theme) => ({
        width: 28,
        height: 28,
        flexShrink: 0,
        display: 'grid',
        placeItems: 'center',
        borderRadius: '50%',
        color: `${color}.main`,
        bgcolor: alpha(theme.palette[color].main, 0.16),
      })}
    >
      {isLoading ? (
        <CircularProgress size={14} thickness={5} color="inherit" />
      ) : (
        <Icon sx={{ fontSize: 16 }} />
      )}
    </Box>
  );
}
